(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["full-face-photo"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('full-face-photo')) {
  const loadedPhotos = new Map();
  function loadPhoto(source) {
    if (!loadedPhotos.has(source)) {
      loadedPhotos.set(source, new Promise((resolve, reject) => {
        const img = new Image();
        const timer = setTimeout(() => reject(new Error('timeout')), 15000);
        img.onload = () => { clearTimeout(timer); resolve(); };
        img.onerror = () => { clearTimeout(timer); reject(new Error('image')); };
        img.src = source;
      }).catch(error => { loadedPhotos.delete(source); throw error; }));
    }
    return loadedPhotos.get(source);
  }
  customElements.define('full-face-photo', class extends HTMLElement {
    connectedCallback() {
      if (this.handler) return;
      const mapping = this.querySelector('[data-photo-sources]');
      if (!mapping) return;
      this.sources = JSON.parse(mapping.textContent);
      this.blushImage = this.querySelector('.full-face-photo__blush');
      this.highlighterImage = this.querySelector('.full-face-photo__highlighter');
      this.loading = this.querySelector('.full-face-photo__loading');
      this.error = this.querySelector('.full-face-photo__error');
      this.version = 0;
      this.handler = event => {
        const section = document.getElementById('MainProduct-' + this.dataset.section);
        if (!section || !section.contains(event.target)) return;
        const picker = event.target.closest('variant-radios, variant-selects');
        if (!picker) return;
        const selected = picker.matches('variant-radios')
          ? Array.from(picker.querySelectorAll('fieldset input:checked'), input => input.value)
          : Array.from(picker.querySelectorAll('select'), select => select.value);
        if (selected.length === 2) this.updatePhoto(selected[0], selected[1]);
      };
      document.addEventListener('change', this.handler);
    }
    disconnectedCallback() {
      document.removeEventListener('change', this.handler);
      this.handler = null;
      this.version++;
    }
    async updatePhoto(blush, highlighter) {
      const version = ++this.version;
      const blushSource = this.sources.blush[blush];
      const highlighterSource = this.sources.highlighter[highlighter];
      this.error.hidden = true;
      this.loading.hidden = false;
      this.setAttribute('aria-busy', 'true');
      try {
        if (!blushSource || !highlighterSource) throw new Error('unmapped');
        await Promise.all([loadPhoto(blushSource), loadPhoto(highlighterSource)]);
        if (version !== this.version || !this.isConnected) return;
        this.blushImage.src = blushSource;
        this.highlighterImage.src = highlighterSource;
        this.dataset.blush = blush;
        this.dataset.highlighter = highlighter;
        this.setAttribute('aria-label', this.dataset.productTitle + ' — ' + blush + ' / ' + highlighter);
      } catch (error) {
        if (version === this.version) this.error.hidden = false;
      } finally {
        if (version === this.version) {
          this.loading.hidden = true;
          this.removeAttribute('aria-busy');
        }
      }
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["highlighter-signup"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('highlighter-signup')) {
  let signupSequence = 0;
  customElements.define('highlighter-signup', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.toggle = this.querySelector('[data-signup-toggle]');
      this.panel = this.querySelector('.highlighter-signup__panel');
      this.form = this.querySelector('form');
      if (!this.toggle || !this.panel || !this.form) return;
      this.initialized = true;
      this.email = this.form.elements.email;
      this.submitButton = this.querySelector('[data-signup-submit]');
      this.error = this.querySelector('.highlighter-signup__error');
      this.success = this.querySelector('.highlighter-signup__success');
      this.intro = this.querySelector('.highlighter-signup__intro');
      this.panel.id = 'highlighter-signup-panel-' + (++signupSequence);
      this.toggle.setAttribute('aria-controls', this.panel.id);
      this.toggle.setAttribute('aria-haspopup', 'dialog');
      this.toggle.disabled = false;
      this.toggle.addEventListener('click', () => this.setOpen(this.panel.hidden));
      this.querySelector('.highlighter-signup__dismiss').addEventListener('click', () => this.setOpen(false));
      this.panel.addEventListener('cancel', event => {
        event.preventDefault();
        this.setOpen(false);
      });
      this.addEventListener('keydown', event => {
        if (event.key === 'Escape' && !this.panel.hidden) {
          event.preventDefault();
          this.setOpen(false);
        }
      });
      this.form.addEventListener('submit', event => this.subscribe(event));
    }
    setOpen(open) {
      if (open) {
        this.panel.hidden = false;
        if (!this.panel.open) this.panel.showModal();
        document.documentElement.classList.add('highlighter-signup-modal-open');
      } else {
        this.panel.close();
        this.panel.hidden = true;
        if (!document.querySelector('dialog.highlighter-signup__panel[open]')) document.documentElement.classList.remove('highlighter-signup-modal-open');
      }
      this.toggle.setAttribute('aria-expanded', String(open));
      if (open) (this.success.hidden ? this.email : this.success).focus({ preventScroll:true });
      else this.toggle.focus({ preventScroll:true });
    }
    disconnectedCallback() {
      if (this.panel && this.panel.open) this.panel.close();
      if (!document.querySelector('dialog.highlighter-signup__panel[open]')) document.documentElement.classList.remove('highlighter-signup-modal-open');
    }
    async subscribe(event) {
      event.preventDefault();
      event.stopPropagation();
      if (this.pending || !this.form.reportValidity()) return;
      this.pending = true;
      this.submitButton.disabled = true;
      this.form.setAttribute('aria-busy', 'true');
      this.error.hidden = true;
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 15000);
      try {
        const registration = new URL(this.dataset.registrationUrl);
        const company = registration.searchParams.get('a');
        const list = registration.searchParams.get('g');
        if (registration.hostname !== 'manage.kmail-lists.com' || !company || !list) throw new Error('configuration');
        const response = await fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(company), {
          method:'POST',
          headers:{'Content-Type':'application/vnd.api+json', 'Accept':'application/vnd.api+json', 'revision':'2026-07-15'},
          credentials:'omit',
          signal:controller.signal,
          body:JSON.stringify({data:{type:'subscription', attributes:{custom_source:'Painted Highlighter launch inline registration', profile:{data:{type:'profile', attributes:{email:this.email.value.trim(), subscriptions:{email:{marketing:{consent:'SUBSCRIBED'}}}}}}}, relationships:{list:{data:{type:'list', id:list}}}}})
        });
        if (response.status !== 202) throw new Error(response.status === 429 ? 'rate' : 'request');
        this.form.hidden = true;
        this.intro.hidden = true;
        this.form.reset();
        this.success.hidden = false;
        if (!this.panel.hidden) this.success.focus({ preventScroll:true });
      } catch (error) {
        this.error.textContent = error.message === 'rate' ? this.dataset.rateError : this.dataset.error;
        this.error.hidden = false;
      } finally {
        clearTimeout(timeout);
        this.pending = false;
        this.submitButton.disabled = false;
        this.form.removeAttribute('aria-busy');
      }
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mascara-linked-swatches"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mascara-linked-swatches')) {
    customElements.define('mascara-linked-swatches', class extends HTMLElement {
      connectedCallback() {
        this.section = this.closest('section');
        this.onChange = (event) => {
          const input = event.target.closest('input[name="mascara-shade"]');
          if (!input) return;
          if (!input.hasAttribute('data-duo') && input.value !== this.dataset.shade) {
            const url = new URL(input.dataset.url, window.location.origin);
            const params = new URL(window.location.href).searchParams;
            if (params.has('preview_theme_id')) url.searchParams.set('preview_theme_id', params.get('preview_theme_id'));
            window.location.assign(url.toString());
            return;
          }
          this.select(input.hasAttribute('data-duo'), true);
        };
        this.addEventListener('change', this.onChange);
        this.select(new URL(window.location.href).searchParams.get('bundle') === 'duo', false);
      }
      disconnectedCallback() { this.removeEventListener('change', this.onChange); }
      select(isDuo, updateUrl) {
        this.section.classList.toggle('mascara-linked--duo', isDuo);
        this.querySelectorAll('input[name="mascara-shade"]').forEach((input) => { input.checked = isDuo ? input.hasAttribute('data-duo') : input.value === this.dataset.shade; });
        this.section.querySelectorAll('[data-mascara-linked-purchase]').forEach((panel) => {
          panel.hidden = panel.dataset.mascaraLinkedPurchase !== (isDuo ? 'duo' : 'single');
          panel.querySelectorAll('[data-mascara-purchase]').forEach((form) => { form.hidden = false; });
        });
        this.section.querySelectorAll('.product__title h1').forEach((heading) => { heading.textContent = isDuo ? this.dataset.duoTitle : this.dataset.singleTitle; });
        const title = this.section.querySelector('#variant-color');
        if (title) { title.textContent = isDuo ? this.dataset.duoSubtitle : this.dataset.shade; title.style.color = isDuo || this.dataset.shade === 'Black' ? '#171717' : '#65433f'; }
        const wrapper = this.section.querySelector('.product__media-wrapper');
        const template = this.querySelector('[data-mascara-linked-image]');
        if (isDuo && wrapper && template && !wrapper.querySelector('.mascara-linked__duo-media')) wrapper.appendChild(template.content.cloneNode(true));
        if (updateUrl) {
          const url = new URL(window.location.href);
          if (isDuo) url.searchParams.set('bundle', 'duo');
          else url.searchParams.delete('bundle');
          window.history.replaceState({}, '', url.pathname + url.search);
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mascara-trio-selector"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mascara-trio-selector')) {
    customElements.define('mascara-trio-selector', class extends HTMLElement {
      connectedCallback() {
        this.section = this.closest('section');
        this.config = JSON.parse(this.querySelector('[data-mascara-trio-data]').textContent);
        this.onClick = (event) => {
          const choice = event.target.closest('[data-choice]');
          if (!choice || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button > 0) return;
          event.preventDefault();
          this.select(choice.dataset.choice, true);
        };
        this.addEventListener('click', this.onClick);
        this.onPopState = () => this.selectFromUrl();
        window.addEventListener('popstate', this.onPopState);
        this.selectFromUrl();
      }
      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
        window.removeEventListener('popstate', this.onPopState);
      }
      selectFromUrl() {
        const params = new URL(window.location.href).searchParams;
        const choice = params.get('bundle') === 'duo' ? 'duo' : params.get('variant');
        this.select(this.config.choices[choice] ? choice : this.config.initial, false);
      }
      select(key, updateUrl) {
        const choice = this.config.choices[key];
        if (!choice) return;
        this.querySelectorAll('[data-choice]').forEach((link) => {
          if (link.dataset.choice === key) link.setAttribute('aria-current', 'true');
          else link.removeAttribute('aria-current');
        });
        this.section.querySelectorAll('[data-mascara-purchase]').forEach((panel) => { panel.hidden = panel.dataset.mascaraPurchase !== key; });
        const isDuo = key === 'duo';
        this.section.classList.toggle('mascara-trio--duo', isDuo);
        const title = this.section.querySelector('#variant-color');
        if (title) { title.textContent = choice.label; title.style.color = choice.color; }
        const mediaWrapper = this.section.querySelector('.product__media-wrapper');
        const duoTemplate = this.querySelector('[data-mascara-duo-media]');
        if (isDuo && duoTemplate && mediaWrapper && !mediaWrapper.querySelector('.mascara-trio__duo-media')) mediaWrapper.appendChild(duoTemplate.content.cloneNode(true));
        if (!isDuo) {
          this.section.querySelectorAll('media-gallery').forEach((gallery) => {
            const featuredId = this.dataset.section + '-' + choice.mediaId;
            gallery.querySelectorAll('.product__media-item[data-media-id]').forEach((item) => {
              const alt = item.dataset.imgAlt || '';
              const visible = item.dataset.mediaId === featuredId || alt === 'Variant: ' + choice.label;
              item.classList.toggle('mascara-trio__media-hidden', !visible);
              item.classList.toggle('product__media-item--variant', !visible);
              if (visible) item.classList.remove('scroll-trigger--offscreen');
            });
            if (choice.mediaId && typeof gallery.setActiveMedia === 'function') gallery.setActiveMedia(this.dataset.section + '-' + choice.mediaId, false);
          });
          const modal = document.getElementById('ProductModal-' + this.dataset.section);
          if (modal) modal.querySelectorAll('[alt^="Variant:"]').forEach((image) => { image.classList.toggle('product__media-item--variant', image.alt !== 'Variant: ' + choice.label); });
        }
        this.section.querySelectorAll('product-form').forEach((form) => { if (typeof form.handleErrorMessage === 'function') form.handleErrorMessage(); });
        if (updateUrl) {
          const url = new URL(window.location.href);
          if (isDuo) { url.searchParams.set('bundle', 'duo'); url.searchParams.delete('variant'); }
          else { url.searchParams.set('variant', key); url.searchParams.delete('bundle'); }
          window.history.replaceState({}, '', url.pathname + url.search);
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
